export default __webpack_public_path__ + "static/akitabox_logo.6265cbedfb8e795ccf1ae7aa1752ea92.svg";